import {Runtime} from "./Runtime";

export type RuntimeTransform<M, E> = (runtime: Runtime<M>) => E;

export function isTransform<M, E>(arg: any): arg is RuntimeTransform<M, E> {
  return typeof arg === "function";
}
